import { createSelector } from 'reselect'
import type { Location } from 'react-router-dom'
import type { State } from 'types/redux'
/**
 * Gets the routing history from the state.
 * @param state - The Redux state
 * @returns Array of location objects representing the routing history
 */
export const getRoutingHistory = (state: State): Location[] =>
  state.routing?.history ?? []
/**
 * Gets the previous location from the routing history.
 * @param state - The Redux state
 * @returns The previous location object, or null if no previous location exists
 */
export const getRoutingPreviousLocation: (
  state: State,
) => Location | null | undefined = createSelector(
  getRoutingHistory,
  history => {
    const length = history.length
    if (length < 2) return null
    return history[length - 2]
  },
)

/**
 * Gets the location before transitions from the routing state.
 * @param state - The Redux state
 * @returns The location object before transitions occurred
 */
export const getLocationBeforeTransitions = (state: State): Location => {
  return state.routing.locationBeforeTransitions
}
